module.exports = __webpack_public_path__ + "blockquote-68cf7b9e5e004bbd5274.svg";